// Read a dot-notation path (`a.b.c`) from a nested object; returns undefined if any segment is missing.
// Shared by dictionaries/triggers for field-path config (dedupe/watermark `by`, match paths, extract*).
export function getPath(source: unknown, path: string): unknown {
  return path.split('.').reduce<unknown>(
    (acc, key) => (acc == null ? acc : (acc as Record<string, unknown>)[key]),
    source
  )
}
